import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { InputDialog, Text, TextPriority, TextTypography } from '..';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { classes } from './InputDialog.visual.st.css';

const title = 'Title';
const subtitle = 'Subtitle';
const longTitle =
  'longlonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglongtitle';
const longSubtitle =
  'longlonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglonglongsubtitle';
const primaryButton = {
  text: 'Primary button',
  onClick: () => {},
};
const secondaryButton = {
  text: 'Secondary button',
  onClick: () => {},
};
const DialogContent = () => (
  <div>
    <p>
      You activated a fake link or button that goes nowhere! The link or button
      is present for demonstration purposes only.
    </p>
  </div>
);

const BWInputDialog = ({ children }) => (
  <InputDialog
    isOpen
    forceBWTheme
    primaryButton={primaryButton}
    secondaryButton={secondaryButton}
  >
    {children}
  </InputDialog>
);

visualize('InputDialog', () => {
  story('simple', () => {
    snap('default props', <InputDialog />);
    snap(
      'custom buttonText',
      <InputDialog
        isOpen
        title={title}
        subtitle={subtitle}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
      >
        {DialogContent()}
      </InputDialog>,
    );
    snap(
      'with a customFooter',
      <InputDialog
        isOpen
        title={title}
        subtitle={subtitle}
        customFooter="CustomFooter"
      >
        {DialogContent()}
      </InputDialog>,
    );
    snap(
      'mobile',
      <TPAComponentsProvider value={{ mobile: true }}>
        <InputDialog
          isOpen
          title={title}
          subtitle={subtitle}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        >
          {DialogContent()}
        </InputDialog>
      </TPAComponentsProvider>,
    );
    snap(
      'rtl',
      <TPAComponentsProvider value={{ rtl: true }}>
        <InputDialog
          isOpen
          title={title}
          subtitle={subtitle}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        >
          {DialogContent()}
        </InputDialog>
      </TPAComponentsProvider>,
    );
    snap(
      'without divider',
      <InputDialog
        isOpen
        title={title}
        subtitle={subtitle}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        withoutDivider
      >
        {DialogContent()}
      </InputDialog>,
    );
    snap(
      'with a long word in title and subtitle',
      <InputDialog
        isOpen
        title={longTitle}
        subtitle={longSubtitle}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
      >
        {DialogContent()}
      </InputDialog>,
    );
    snap('with style overrides', () => (
      <InputDialog
        isOpen
        title={title}
        subtitle={subtitle}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        className={classes.root}
      >
        {DialogContent()}
      </InputDialog>
    ));

    snap('with WST overrides', () => (
      <InputDialog
        isOpen
        title={title}
        subtitle={subtitle}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        className={classes.wstOverrides}
      >
        {DialogContent()}
      </InputDialog>
    ));
  });

  story('Force black and white theme', () => {
    snap('InputDialog with Text', () => {
      return (
        <BWInputDialog>
          <Text
            typography={TextTypography.largeTitle}
            priority={TextPriority.primary}
          >
            Primary text
          </Text>
          <div style={{ marginTop: '24px', marginBottom: '36px' }}>
            <Text
              typography={TextTypography.listText}
              priority={TextPriority.secondary}
            >
              Secondary text
            </Text>
          </div>
        </BWInputDialog>
      );
    });
  });
});
